import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
import createAction from "./utils/createMetaAction";
export const updateFeatureLengthsToHide = createAction(
  "updateFeatureLengthsToHide"
);
export const toggleFeatureLengthsToHide = createAction(
  "toggleFeatureLengthsToHide"
);
export default createMergedDefaultStateReducer(
  {
    [updateFeatureLengthsToHide]: (state, payload) => {
      return { ...state, ...payload };
    },
    [toggleFeatureLengthsToHide]: (state) => {
      return { ...state, enabled: !state["enabled"] };
    }
  },
  { enabled: false, min: 0, max: 800 }
);
